import { getFlixTldFromHostname } from 'app/functions';
import { setCookie } from 'app/storage/coookie';

export const setCookieForDomain = ({
  cookieName,
  cookieValue,
  expirationTime,
}: {
  cookieName: string;
  cookieValue: string;
  expirationTime?: number;
}) => {
  const domain = getFlixTldFromHostname(document.location.hostname) || document.location.hostname;
  return setCookie(cookieName, cookieValue, { domain, expires: expirationTime });
};
